import i18n, { LOCALES } from "@/i18n";

/** Locale attivo per date/numeri: la valuta resta sempre in euro. */
export const locale = () => LOCALES[i18n.language] || "it-IT";

export const fmtDate = (d, opts = { day: "2-digit", month: "2-digit", year: "numeric" }) =>
  d ? new Date(d).toLocaleDateString(locale(), opts) : "";

export const fmtDateTime = (d, opts = {
  day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
}) => (d ? new Date(d).toLocaleString(locale(), opts) : "");

export const fmtTime = (d) =>
  (d ? new Date(d).toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit" }) : "");

export const fmtMoney = (n, opts = {}) =>
  new Intl.NumberFormat(locale(), {
    style: "currency", currency: "EUR", maximumFractionDigits: 2, useGrouping: "always", ...opts,
  }).format(Number(n) || 0);

export const fmtNumber = (n, opts = {}) =>
  new Intl.NumberFormat(locale(), opts).format(Number(n) || 0);
